module.exports = __webpack_public_path__ + "static/img/coins.01e199e2.png";